import React from 'react';
import { Box, Container, Paper, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LocsyTermsSection from '../components/LocsyTermsSection';
import PublicSiteLayout from '../layouts/PublicSiteLayout';
import SeoHead from '../components/SeoHead';

export default function LocsyTermsPage() {
  return (
    <PublicSiteLayout>
      <SeoHead
        title="Loksy Terms & Conditions"
        description="Terms and conditions for Loksy Citizen and Loksy Mitra marketplace apps."
        canonicalUrl="https://services.knls.in/locsy-terms-and-conditions"
      />
      <Box sx={{ py: { xs: 2, sm: 4 } }}>
        <Container maxWidth="md">
          <Paper
            elevation={0}
            sx={{ p: { xs: 2, sm: 4 }, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}
          >
            <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 800 }}>
              Loksy Terms & Conditions
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Loksy Citizen & Mitra — last updated 19 September 2026. Please read carefully before registration or use.
            </Typography>

            <LocsyTermsSection />

            <Box sx={{ mt: 4, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
              <Button component={RouterLink} to="/privacy-policy" variant="outlined">
                Privacy Policy
              </Button>
              <Button component={RouterLink} to="/disclaimer" variant="outlined">
                Platform Disclaimer
              </Button>
              <Button component={RouterLink} to="/refund-policy" variant="outlined">
                Refund Policy
              </Button>
              <Button component={RouterLink} to="/cookie-policy" variant="text">
                Cookie Policy
              </Button>
            </Box>
          </Paper>
        </Container>
      </Box>
    </PublicSiteLayout>
  );
}
